document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const featuredSection = document.querySelector('.section-featured-collection');
    
    if (featuredSection) {
      const themeScroll = featuredSection.querySelector('theme-scroll');
      const productGrid = featuredSection.querySelector('.products');
      const productsToShow = 18;
      
      if (productGrid && themeScroll) {
        const allProducts = Array.from(productGrid.querySelectorAll('.carousel__slide'));
        
        // Shuffle all products
        for (let i = allProducts.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [allProducts[i], allProducts[j]] = [allProducts[j], allProducts[i]];
        }
        
        // Keep only the first 18 after shuffling
        const selectedProducts = allProducts.slice(0, productsToShow);
        const productsToRemove = allProducts.slice(productsToShow);
        
        // Remove extra products
        productsToRemove.forEach(product => product.remove());
        
        // Clear and re-add selected products
        productGrid.innerHTML = '';
        selectedProducts.forEach(product => productGrid.appendChild(product));
        
        // Try to reinitialize the theme-scroll component
        if (typeof themeScroll.connectedCallback === 'function') {
          themeScroll.connectedCallback();
        }
        
        // Dispatch a custom event to trigger reinitialization
        themeScroll.dispatchEvent(new Event('theme:scroll:refresh'));
        
        console.log('Showing ' + productsToShow + ' random products from ' + allProducts.length);
      }
    }
  }, 200);
});
